// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3JEct","buttons":"Footer_buttons__1ZFpU"};